export const classNames = (classNameList: (boolean | string | undefined)[]) => {
  const filteredClassNameList = classNameList?.filter(Boolean).join(' ');

  return filteredClassNameList?.length ? filteredClassNameList : undefined;
};
